import Icon from "assets/icons";
import FormContainer from "shared/form";
import ButtonType from "shared/enums/ButtonTypes";
import { useCopies } from "shared/hooks/useCopies";
import { InvoicePaymentFieldName } from "./enum";
import { InvoicePaymentPropTypes } from "./types";
import { useInvoicePayerPaymentService } from "./service";
import FormTextField from "shared/form/fields/textField";
import Button from "shared/components/button";

function InvoicePayment(props: InvoicePaymentPropTypes) {
  const copies = useCopies();
  const service = useInvoicePayerPaymentService(props);

  return (
    <FormContainer
      initialValues={service.initialValues}
      onSubmit={service.invoicePayerPaymentRequestHandler}
      enableReinitialize={true}
      isReadOnly={service.isFormReadOnly}
      validationSchema={service.validationSchema}>
      <FormContainer.Form className="paymentWrapper_body">
        <div className="payment_container payment_containerInvoice">
          <FormTextField
            required
            className="transformToLowerCase"
            disabled={service.isFormReadOnly}
            name={InvoicePaymentFieldName.EMAIL}
            label={copies.get("invoice.payment.form.field.email")}
          />
          <FormTextField
            required
            disablePaste
            autoComplete="off"
            className="transformToLowerCase"
            disabled={service.isFormReadOnly}
            name={InvoicePaymentFieldName.CONFIRM_EMAIL}
            label={copies.get("invoice.payment.form.field.email.confirm")}
          />
        </div>
        <div className="paymentWrapper_btnWrapper">
          <Button.Save
            label={copies.get("invoice.payment.form.btn.submit")}
            icon={<Icon.Send />}
            type={ButtonType.SUBMIT}
          />
        </div>
      </FormContainer.Form>
    </FormContainer>
  );
}

export default InvoicePayment;
